import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as debinActions } from "reducers/debin";
import { getLimitDate } from "util/date";
import moment from "moment";
import * as i18n from "util/i18n";

export const useTags = (optionDebin, isReceived, isRecurrent, isEmited, isScheduled) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { filterRecurrencyList } = useSelector((state) => state.debin);

    const filterListTags = {
        dateFrom: moment(filterRecurrencyList?.dateFrom).format("YY-MM-DD") || "",
        dateTo: moment(filterRecurrencyList?.dateTo).format("YY-MM-DD") || "",
        status: filterRecurrencyList?.status || "",
        seller: filterRecurrencyList?.seller || "",
        pageNumber: filterRecurrencyList?.pageNumber,
        createdFrom: moment(filterRecurrencyList?.createdFrom).format("YY-MM-DD") || "",
        createdTo: moment(filterRecurrencyList?.createdTo).format("YY-MM-DD") || "",
        account: filterRecurrencyList?.account || "",
        cbu: filterRecurrencyList?.cbu || "",
    };

    let sellerValue;
    if (isRecurrent || isScheduled) {
        sellerValue = { id: "seller", text: i18n.get("debin.seller") };
    }
    if (isReceived) {
        sellerValue = { id: "seller", text: i18n.get("debin.seller") };
    }
    if (isEmited) {
        sellerValue = { id: "seller", text: i18n.get("debin.emitter") };
    }
    const tagOptionsCommon = () => {
        let tagOptions;
        if (isRecurrent) {
            tagOptions = {
                account: { id: "account", text: i18n.get("debin.account.label") },
                seller: sellerValue,
                status: { id: "status", text: i18n.get("debin.status.label") },
                createdFrom: { id: "createdFrom", text: i18n.get("debin.createdRange.label") },
            };
        }
        if (isEmited || isReceived || isScheduled) {
            tagOptions = {
                seller: sellerValue,
                status: { id: "status", text: i18n.get("debin.status.label") },
                dateFrom: { id: "dateFrom", text: i18n.get(isScheduled ? "debin.payedRange.scheduled.text" : "debin.payedRange.text") },
            };
        }
        return tagOptions;
    };
    const commonTagOptions = tagOptionsCommon();

    const tagOptions = {
        "received.debin": {
            ...commonTagOptions,
            receiver: { id: "receiver", text: i18n.get("debin.receiver.label") },
        },
        "recurrent.debin": {
            ...commonTagOptions,
            recurrent: { id: "recurrent", text: i18n.get("debin.recurrent.label") },
        },
        "emited.debin": {
            ...commonTagOptions,
            recurrent: { id: "recurrent", text: i18n.get("debin.emited.label") },
        },
    };

    const dateToCompare = moment(getLimitDate(-184)).format("YY-MM-DD");
    const dateToCompareFrom = moment(getLimitDate(-184)).format("YY-MM-DD");
    useEffect(() => {
        let activeTags;
        if (isRecurrent) {
            activeTags = Object.entries(filterListTags)
                .filter(
                    (activeFilters) =>
                        !activeFilters.includes("") &&
                        !activeFilters.includes("TODOS") &&
                        !activeFilters.includes("Todos") &&
                        !activeFilters.includes(null) &&
                        !activeFilters.includes(dateToCompare),
                )
                .map((filter) => filter[0])
                .filter((filterKey) => !!tagOptions[optionDebin][filterKey])
                .map((key) => tagOptions[optionDebin][key]);
        }
        if (isEmited || isReceived || isScheduled) {
            activeTags = Object.entries(filterListTags)
                .filter(
                    (activeFilters) =>
                        !activeFilters.includes("") &&
                        !activeFilters.includes("Todos") &&
                        !activeFilters.includes("TODOS") &&
                        !activeFilters.includes(null) &&
                        !activeFilters.includes(dateToCompareFrom),
                )
                .map((filter) => filter[0])
                .filter((filterKey) => !!tagOptions[optionDebin][filterKey])
                .map((key) => tagOptions[optionDebin][key]);
        }

        setTags(activeTags);
    }, [filterRecurrencyList]);

    const actionDispatch = (filter) => {
        if (isRecurrent) {
            dispatch(debinActions.getDebinRecurrencies(filter));
        }
        if (isReceived) {
            dispatch(debinActions.loadIncomingRequests(filter));
        }
        if (isEmited) {
            dispatch(debinActions.loadSentRequests(filter));
        }
        if (isScheduled) {
            dispatch(debinActions.scheduledDebinList(filter));
        }
    };

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;

        if (
            deletedFilter !== "createdFrom" &&
            deletedFilter !== "dateFrom" &&
            deletedFilter !== "status" &&
            deletedFilter !== "account" &&
            deletedFilter !== "sellerRecived" &&
            deletedFilter !== "sellerEmitted" &&
            deletedFilter !== "seller"
        ) {
            const tagFilters = {
                ...filterRecurrencyList,
                [deletedFilter]: "",
            };
            dispatch(debinActions.setRecurrencyDebinFilters(tagFilters));
            actionDispatch(tagFilters);
            return;
        }

        if (deletedFilter === "createdFrom") {
            if (isRecurrent) {
                const tagFilters = {
                    ...filterRecurrencyList,
                    createdFrom: getLimitDate(-184),
                    createdTo: getLimitDate(7),
                };
                dispatch(debinActions.setRecurrencyDebinFilters(tagFilters));
                actionDispatch(tagFilters);
            }
            return;
        }

        if (deletedFilter === "dateFrom") {
            if (isReceived || isEmited || isScheduled) {
                const tagFilters = {
                    ...filterRecurrencyList,
                    dateFrom: getLimitDate(-184),
                    dateTo: moment().toDate(),
                };
                dispatch(debinActions.setRecurrencyDebinFilters(tagFilters));
                actionDispatch(tagFilters);
            }
            return;
        }
        if (deletedFilter === "status") {
            let tagFilters;
            if (isRecurrent) {
                tagFilters = {
                    ...filterRecurrencyList,
                    status: "TODOS",
                };
            }
            if (isReceived || isEmited || isScheduled) {
                tagFilters = {
                    ...filterRecurrencyList,
                    status: "Todos",
                };
            }
            dispatch(debinActions.setRecurrencyDebinFilters(tagFilters));
            actionDispatch(tagFilters);
            return;
        }
        if (deletedFilter === "account") {
            const tagFilters = {
                ...filterRecurrencyList,
                account: "",
                cbu: "",
            };
            dispatch(debinActions.setRecurrencyDebinFilters(tagFilters));
            actionDispatch(tagFilters);
        }

        if (deletedFilter === "seller" || deletedFilter === "sellerRecived" || deletedFilter === "sellerEmitted") {
            const tagFilters = {
                ...filterRecurrencyList,
                seller: "",
            };
            dispatch(debinActions.setRecurrencyDebinFilters(tagFilters));
            actionDispatch(tagFilters);
        }
    };
    const handleCleanFilters = () => {
        let clearFilters;
        if (isRecurrent) {
            clearFilters = {
                ...filterRecurrencyList,
                createdFrom: getLimitDate(-184),
                createdTo: getLimitDate(7),
                seller: "",
                account: "TODOS",
                status: "TODOS",
                cbu: "",
                statusRecurrent: "TODOS",
            };
        }
        if (isReceived || isScheduled) {
            clearFilters = {
                ...filterRecurrencyList,
                dateFrom: getLimitDate(-184),
                dateTo: moment().toDate(),
                seller: "",
                status: "Todos",
                sellerRecived: "",
                statusReceived: "Todos",
            };
        }
        if (isEmited) {
            clearFilters = {
                ...filterRecurrencyList,
                dateFrom: getLimitDate(-184),
                dateTo: moment().toDate(),
                seller: "",
                status: "Todos",
                sellerEmitted: "",
                statusEmited: "Todos",
            };
        }
        dispatch(debinActions.setRecurrencyDebinFilters(clearFilters));
        actionDispatch(clearFilters);
    };

    return { tags, handleDelete, handleCleanFilters };
};

export default useTags;
